import { Platform, StyleSheet } from 'react-native';

import { COLOR } from 'utils/colors';
import {
    androidScreenMarginBottom,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: COLOR.LIGHT_GREY,
        borderRadius: 12,
        overflow: 'hidden',
        position: 'absolute',
        paddingVertical: 8,
        marginBottom: androidScreenMarginBottom,
        ...Platform.select({
            web: {
                boxShadow:
                    '0px 0px 0px 0px rgba(0, 0, 0, 0.07), 0px 5px 12px 0px rgba(0, 0, 0, 0.07), 0px 21px 21px 0px rgba(0, 0, 0, 0.06), 0px 48px 29px 0px rgba(0, 0, 0, 0.04), 0px 85px 34px 0px rgba(0, 0, 0, 0.01), 0px 133px 37px 0px rgba(0, 0, 0, 0.00)',
            },
            default: {
                shadowColor: COLOR.BLACK,
                shadowOffset: {
                    width: 2,
                    height: 2,
                },
                shadowOpacity: 0.17,
                shadowRadius: 2.54,
                elevation: 3,
            },
        }),
    },
    listContainer: {
        flexGrow: 1,
    },
    safeArea: {
        flex: 1,
        marginHorizontal: widthPercentageToDP(0, 160),
        backgroundColor: COLOR.background,
    },
    scroll: {
        flex: 1,
        paddingBottom: 24,
        backgroundColor: COLOR.COD_GRAY_LIGHT,
    },
    backgroundStyle: {
        backgroundColor: COLOR.background,
    },
    modalContainer: {
        flex: 1,
        marginBottom: androidScreenMarginBottom,
    },
    svgArrowContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
    },
});

export default styles;
